
import React from 'react';

const LeadDisplay = () => {
  return (
    <div className="bg-gradient-to-br from-[#A855F7] to-[#2563EB] rounded-[1.5rem] p-5 mt-4 text-white shadow-xl relative overflow-hidden group">
      <div className="absolute top-0 right-0 -mr-8 -mt-8 opacity-10 group-hover:opacity-20 transition-opacity text-white">
        <svg viewBox="0 0 100 100" className="w-32 h-32 fill-current">
          <path d="M30 20 H15 V85 H85 V70 M85 45 V30 L35 65 L85 15 M85 15 H55 M85 15 V45" />
        </svg>
      </div>

      <div className="relative z-10">
        <h3 className="font-extrabold text-[15px] mb-1 tracking-tight">Scale Your Business</h3>
        <p className="text-white/80 text-[11px] mb-4 leading-normal max-w-[85%]">
          Vancouver's top SEO & Web experts are ready to audit your project for free.
        </p>
        <button className="w-full bg-white text-[#2563EB] font-bold py-2.5 rounded-xl text-xs hover:bg-gray-50 transition-all shadow-md active:scale-95 flex items-center justify-center gap-2">
          Book Free Strategy Call
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default LeadDisplay;
